import { BenchMode, CaseAccessState, MiniTabLabels } from '../../../enums';
import { defaultSet } from '../../artifacts/artifact-sets';
import { LOAD_STATES } from '../../load-states';
import { relatedCasesSortablePageable } from '../utils/pagination-utils';

const STUB_ORG_CONTEXT = {
  organizationId: 0,
  organizationName: '',
  organizationCode: '',
  organizationType: '',
  tenantId: '',
  parentLevel: 1,
  healthSystemTenantId: '',
  healthSystemCode: '',
  healthSystemName: '',
  displayName: '',
  cognitoEnabled: false,
  resources: [],
  serviceLines: []
};

const cursorAPIContext = {
  worklistContext: {},
  servicedeskMode: false,
  workitemId: '',
  sessionId: '',
  qaCollectionUuid: '',
  launchConfigServiceLine: ''
};

const emptyCase: CMxAPI.Case = Object.freeze({
  id: 0,
  caseRuns: []
});

const formErrors: CMxCommonApp.FormErrors = {
  status: '',
  message: null,
  errors: [],
  fieldErrors: {}
};

const groupedCases: CMxCommonApp.GroupedCases = {
  groupType: 'none',
  caseRuns: []
};

const holdCase: CMxAPI.HoldCaseResponse = {
  hold_reason: '',
  comment: '',
  coding_manager_id: ''
};

export const DEFAULT_BENCH_EDITABLE: Accelerate.BenchEditableState = {
  editable: false,
  waiting: false,
  submitted: false,
  cancelled: false,
  reason: ''
};

export const DEFAULT_SUGGESTED_CODES: CMxCommonApp.SuggestedCodes = {
  cpt: {
    encounterList: [],
    caseList: [],
    codeSourceList: []
  },
  modifier: {
    encounterList: [],
    caseList: [],
    codeSourceList: []
  },
  icd: {
    encounterList: [],
    caseList: [],
    codeSourceList: []
  }
};

export const codeBenchState: Accelerate.BenchApplicationState = {
  capabilities: {
    userContext: { ...STUB_ORG_CONTEXT },
    roles: [],
    holdCaseStatus: { hold_reason: '', comment: '', coding_manager_id: '' },
    capabilities: {},
    cursorAPIContext,
    parentCaserunUid: null,
    parentCase: false,
    activeItem: {} as CMxAPI.CaseRun,
    submitInProgress: false,
    activeServiceLineName: '',
    excludeCasePermissionsConfig: null
  },
  displayCancellation: false,
  organization: null,
  prompt: null,
  activations: {
    panel: {},
    property: {},
    spans: {}
  },
  propertyConfig: {
    patient: [],
    summary: [],
    expanded: []
  },
  dynamicPropertyConfig: null,
  fallbackPropertyConfig: null,
  modalURL: null,
  activeItem: {} as CMxAPI.CaseRun,
  //@ts-ignore
  processInstance: null,
  codeDescriptions: {},
  codeEdits: {},
  counts: {
    procedures: 0,
    diagnosis: 0,
    modifiers: 0
  },
  hostCaseId: null,
  chargeSessions: [],
  preCommitChargeSessions: [],
  groupedCases,
  cases: [],
  activity: [],
  codableInvoices: [],
  nonCodeBench: false,
  userContext: null,
  benchEditable: { ...DEFAULT_BENCH_EDITABLE },
  loadState: LOAD_STATES.initial,
  artifactLoadState: LOAD_STATES.initial,
  billingGroupLoadState: LOAD_STATES.done,
  relatedCasesLoadState: LOAD_STATES.done,
  refreshList: true,
  formErrors,
  artifactSet: defaultSet,
  artifactShowAll: false,
  searchResults: {},
  codeSearchResultsV2: {},
  invoiceOptions: {
    invoices: [],
    required_fields: [],
    summary: {
      departments: {},
      fee_schedules: {},
      all_departments: [],
      existing_departments: []
    }
  },
  notes: [],
  artifactList: [],
  stages: [],
  displayTimeline: false,
  roles: [],
  caseRuns: {},
  displayAddCharge: false,
  showAddChargeError: false,
  showAddChargeLoading: false,
  showFeedBack: false,
  feedback: {
    id: null,
    message: '',
    dismissable: true
  },
  showSubmittedFeedback: false,
  showLoadingSubmission: false,
  showLoadingCancelation: false,
  showCanceledFeedback: false,
  submittedFeedbackTimer: false,
  showSizeExpWarning: false,
  showvitalwareIssuesModal: false,
  hidevitalwareIssuesModal: false,
  caseEdits: {},
  toggleHoldCaseModal: false,
  toggleCaseCommentModal: false,
  toggleExclusionCaseModal: false,
  showLateCaseClearModal: false,
  toggleSplitCaseModal: false,
  submitOldCaseModal: false,
  vitalwareIssues: [],
  mergeSplitHistoryIssues: [],
  documentImprovementIssues: [],
  holdIssues: [],
  holdCaseStatus: { ...holdCase },
  cursorAPIContext: {
    worklistContext: {},
    servicedeskMode: false,
    workitemId: '',
    sessionId: '',
    qaCollectionUuid: '',
    launchConfigServiceLine: ''
  },
  entries: [],
  relatedCases: [],
  relatedCasesPageable: { ...relatedCasesSortablePageable },
  noteTypes: [],
  providerRoleTypeConfig: [],
  customClaimsRelatedCasesLoadState: LOAD_STATES.done,
  customClaimsRelatedCases: [],
  flagList: [],
  activeNote: {} as CMxCommonApp.DecoratedNote,
  caseAccessTime: '',
  activeMiniTab: MiniTabLabels.CHARGES_LABEL,
  activeVerticalMiniTab: MiniTabLabels.NOTES_LABEL,
  showUnresolvedDocuments: false,
  showSideNavBar: true,
  benchMode: BenchMode.CODE,
  caseVersions: [],
  suggestedCodes: { ...DEFAULT_SUGGESTED_CODES },
  submitInProgress: false,
  sourceInvoices: {
    sourceInvoices: [],
    sourceInvoicesLoadState: LOAD_STATES.initial
  },
  //TODO : All props to CaseDetail are implicitly added to BenchApplicationState CDMX-2542 even though they are state elsewhere such as AMP-UI
  filterData: [] as CMxCommonApp.SharedFilter[],
  relatedCasesFilterSelection: {} as CMxCommonApp.FilterSelection,
  caseAccessState: CaseAccessState.NONE
};
